import { render, staticRenderFns } from "./callNumDialog.vue?vue&type=template&id=ed226998&scoped=true"
import script from "./callNumDialog.vue?vue&type=script&lang=js"
export * from "./callNumDialog.vue?vue&type=script&lang=js"
import style0 from "./callNumDialog.vue?vue&type=style&index=0&id=ed226998&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed226998",
  null
  
)

export default component.exports